import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PasswordValidator, PasswordStrength } from '../../_validator/password-validator';

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.css']
})
export class PasswordStrengthComponent implements OnChanges {
  @Input() password: string;
  @Input() showRequirements = true;

  strength: PasswordStrength;
  requirements = PasswordValidator.getRequirements();
  progressBarClass = '';
  progressPercentage = 0;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.password) {
      this.updateStrength();
    }
  }

  updateStrength(): void {
    if (!this.password) {
      this.strength = null;
      this.progressPercentage = 0;
      this.progressBarClass = '';
      return;
    }

    this.strength = PasswordValidator.validatePassword(this.password);

    // Calculate progress percentage based on score
    this.progressPercentage = Math.min((this.strength.score / 6) * 100, 100);

    // Set progress bar class based on strength
    switch (this.strength.strength) {
      case 'Very Strong':
        this.progressBarClass = 'bg-success';
        break;
      case 'Strong':
        this.progressBarClass = 'bg-info';
        break;
      case 'Medium':
        this.progressBarClass = 'bg-warning';
        break;
      case 'Weak':
      default:
        this.progressBarClass = 'bg-danger';
        break;
    }
  }

  isRequirementMet(requirement: string): boolean {
    if (!this.password) {
      return false;
    }

    // Check each requirement individually
    if (requirement.includes('8 characters')) {
      return this.password.length >= 8;
    }
    if (requirement.includes('uppercase')) {
      return /[A-Z]/.test(this.password);
    }
    if (requirement.includes('lowercase')) {
      return /[a-z]/.test(this.password);
    }
    if (requirement.includes('number')) {
      return /[0-9]/.test(this.password);
    }
    if (requirement.includes('special')) {
      return /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password);
    }
    return false;
  }
}